import { useEffect } from "react";
import useScript from 'react-script-hook';
import * as Sentry from "@sentry/react";

export default ({ user }) => {

  const [loading, error] = useScript({ src: 'https://static.ads-twitter.com/oct.js' });

  useEffect(() => {
    if (!loading && !error && user) {

      setTimeout(() => {
        if (!window.twttr?.conversion?.trackPid) {
          return;
        }

        try {
          window.twttr.conversion.trackPid('o9oxj', { tw_sale_amount: 0, tw_order_quantity: 0 });
        } catch (e) {
          Sentry.captureException(e);
        }

      }, 5000);

    }
  }, [loading, error, user]);


  return null;
};
